import React, { useEffect, useState } from "react"
import { FaPen, FaX } from "react-icons/fa6"
import {
  Breadcrumb,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap"
import LeftImage from "../assets/images/social-media.jpg"
import Swal from "sweetalert2"
import Loader from "components/Loader/loader"
import {
  fetchData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import { useNavigate } from "react-router-dom"

const SocialMedia = () => {
  const navigate = useNavigate()

  const [linkid, setLinkId] = useState("")
  const [links, setLinks] = useState({
    twitter: "",
    facebook: "",
    instagram: "",
    linkedin: "",
  })
  const [loading, setloading] = useState(false)

  useEffect(() => {
    getSocialMediaLinks()
  }, [])

  async function getSocialMediaLinks() {
    const APIData = await fetchData(setloading, "social/media")

    if (APIData?.success) {
      setLinkId(APIData?.socialMedia?.[0]?._id)
      setLinks({
        twitter: APIData?.socialMedia?.[0]?.socialMedia?.twitter,
        facebook: APIData?.socialMedia?.[0]?.socialMedia?.facebook,
        instagram: APIData?.socialMedia?.[0]?.socialMedia?.instagram,
        linkedin: APIData?.socialMedia?.[0]?.socialMedia?.linkedin,
      })
    }
  }

  const handleChange = e => {
    const { name, value } = e.target
    setLinks(prev => ({ ...prev, [name]: value }))
  }

  const handleUpdate = async e => {
    e.preventDefault()

    const APIData = await FetchPutData(setloading, "social/media", linkid, {
      socialMedia: links,
    })

    if (APIData?.data?.success) {
      Swal.fire({
        title: "SocialMedia Links Updated Successfully",
        icon: "success",
      })
      getSocialMediaLinks()
    } else {
      Swal.fire({
        title: "Something went wrong",
        icon: "error",
        description: APIData?.response?.data?.message,
      })
    }
  }

  const handleCancel = e => {
    e.preventDefault()
    navigate(-1)
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="User Query" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <Row>
                  {/* Left Side - Image */}
                  <Col
                    lg="6"
                    className="d-flex justify-content-center align-items-center"
                  >
                    <img
                      src={LeftImage}
                      alt="Manage Social Handles"
                      className="img-fluid w-50"
                    />
                  </Col>

                  {/* Right Side - Form */}
                  <Col lg="6">
                    <Form>
                      <div className="d-flex justify-content-between align-items-center gap-2 mt-3">
                        <h3 className="mb-0">Social Media Handles</h3>
                      </div>
                      <div className="seprate-line"></div>
                      <Row>
                        <FormGroup className="col-xl-6">
                          <Label for="twitter">Twitter</Label>
                          <Input
                            type="url"
                            name="twitter"
                            id="twitter"
                            value={links.twitter}
                            onChange={handleChange}
                            placeholder="Enter Twitter link"
                          />
                        </FormGroup>

                        <FormGroup className="col-xl-6">
                          <Label for="facebook">Facebook</Label>
                          <Input
                            type="url"
                            name="facebook"
                            id="facebook"
                            value={links.facebook}
                            onChange={handleChange}
                            placeholder="Enter Facebook link"
                          />
                        </FormGroup>

                        <FormGroup className="col-xl-6">
                          <Label for="instagram">Instagram</Label>
                          <Input
                            type="url"
                            name="instagram"
                            id="instagram"
                            value={links.instagram}
                            onChange={handleChange}
                            placeholder="Enter Instagram link"
                          />
                        </FormGroup>

                        <FormGroup className="col-xl-6">
                          <Label for="linkedin">LinkedIn</Label>
                          <Input
                            type="url"
                            name="linkedin"
                            id="linkedin"
                            value={links.linkedin}
                            onChange={handleChange}
                            placeholder="Enter LinkedIn link"
                          />
                        </FormGroup>
                      </Row>
                      <div className="d-flex gap-2 mt-3">
                        <button
                          className="btn btn-add"
                          type="button"
                          onClick={handleUpdate}
                        >
                          <FaPen className="me-2" size={14} />
                          Update
                        </button>
                        <button
                          className="btn btn-cancel"
                          onClick={handleCancel}
                        >
                          <FaX className="me-2" size={14} />
                          Cancel
                        </button>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default SocialMedia
